import { featureFlags } from "@/contexts/CdpProvider";
export function isFeatureFlagActive(flagName) {
    return (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags[flagName]) === "on";
}
